import { render, staticRenderFns } from "./DownloadStoreRight.vue?vue&type=template&id=4a16182f&scoped=true&"
import script from "./DownloadStoreRight.vue?vue&type=script&lang=js&"
export * from "./DownloadStoreRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a16182f",
  null
  
)

export default component.exports